import {action, observable} from 'mobx';
import agent from '../agent';

class CommonStore {
    @observable gtmCode = "";

    @action setGtmCode(code) {
        this.gtmCode = code;
    }

    getGtmList(url) {
        return agent.GTM.getGtmTag(url);
    }
}

export default new CommonStore();
